const UserRole = {

    // FIELDS
    "user": "User",
    "role": "Role",
    "search": "Search",

    // PAGE HEADER
    "user_role": "User Role",

    // ERROR
    "error_user": "Select User",
    "error_role": "Select Role",

    // TABLE HEADER
    "table_user": 'USER',
    "table_role": "ROLE",

}

export default UserRole;